// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__rmBFm","large":"styles_large__2NbLi"};